import { Link, NavLink, useNavigate } from "react-router-dom";
import ThemeSwitcher from "../ThemeSwitcher";
import { useEffect, useState } from "react";
import { getDecodedToken } from "../auth";
import VoiceNavigator, { commandMap } from "../components/VoiceNavigation";

function Header() {
  const [search, setSearch] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const navigate = useNavigate();

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error("Fullscreen Not Working");
      });
    } else {
      document.exitFullscreen();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };

  const [user] = useState(() => getDecodedToken());

  const userRole = user?.roles;

  const moduleAccess = {
    "Admin Users": ["Master Admin", "Admin Users"],
    "Front Office": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Principal",
      "Front Office",
    ],
    "Student Information": [
      "Master Admin",
      "Principal",
      "Admin",
      "Sub Admin",
      "Student Information",
    ],
    "Fees Collection": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Fees Collection",
    ],
    "Behaviour Records": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Principal",
      "Behaviour Records",
    ],
    Expenses: ["Master Admin", "Admin", "Expenses"],
    Attendance: [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Principal",
      "Attendance",
    ],
    "Human Resource": ["Master Admin", "Admin", "Principal", "Human Resource"],
    Library: ["Master Admin", "Admin", "Sub Admin", "Library", "Principal"],
    "Transport Management": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Transport Management",
    ],
    Examinations: [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Examinations",
      "Principal",
    ],
    Communicate: [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Communicate",
      "Principal",
    ],
    Homework: ["Master Admin", "Admin", "Sub Admin", "Principal", "Homework"],
    Inventory: ["Master Admin", "Admin", "Sub Admin", "Inventory"],
    Certificate: ["Master Admin", "Admin", "Sub Admin", "Certificate"],
    Timetable: ["Master Admin", "Admin", "Sub Admin"],
    Reports: ["Master Admin", "Admin", "Sub Admin"],
    Vendor: ["Master Admin", "Admin", "Sub Admin"],
    Website: ["Master Admin", "Admin", "Sub Admin", "Principal", "Website"],
  };

  const hasAccess = (moduleName, userRoles) => {
    const roles = Array.isArray(userRoles)
      ? userRoles
      : typeof userRoles === "string"
        ? [userRoles]
        : [];

    const allowedRoles = (moduleAccess[moduleName] || []).map((r) =>
      r.toLowerCase().trim(),
    );
    return roles
      .map((r) => r.toLowerCase().trim())
      .some((r) => allowedRoles.includes(r));
  };

  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .replace(/please|show|open|go to|me|the|all|list|of/gi, "")
      .replace(/\b(fees|fee)\b/g, "fees")
      .replace(/\s+/g, " ")
      .trim();
  };

  const getSuggestion = (input) => {
    const cleaned = normalizeText(input);

    if (!cleaned) return "";

    const match = commandMap.find((cmd) =>
      cmd.keywords.some((keyword) => {
        const normalizedKeyword = normalizeText(keyword);
        return normalizedKeyword.includes(cleaned);
      }),
    );

    return match ? match.keywords[0] : "";
  };

  useEffect(() => {
    const suggestionText = getSuggestion(search);
    setSuggestion(suggestionText);
  }, [search]);

  const getRemainingText = () => {
    if (!suggestion) return "";

    const lowerSearch = search.toLowerCase();
    const lowerSuggestion = suggestion.toLowerCase();

    if (lowerSuggestion.includes(lowerSearch)) {
      const index = lowerSuggestion.indexOf(lowerSearch);
      return suggestion.slice(index + search.length);
    }

    return "";
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleKeyDown = (e) => {
    if ((e.key === "Tab" || e.key === "ArrowRight") && suggestion) {
      e.preventDefault();
      setSearch(suggestion);
    }

    if (e.key === "Enter") {
      const match = commandMap.find((cmd) =>
        cmd.keywords.some((k) =>
          normalizeText(search).includes(normalizeText(k)),
        ),
      );

      if (match) {
        navigate(match.route);
        setSearch("");
        setSuggestion("");
      }
    }
  };

  return (
    <>
      <nav className="navbar-vertical navbar z-3">
        <div className="vh-100 overflow-y-scroll" data-simplebar="">
          <div className="card bg-primary shadow-none rounded-top-0 text-center mx-3 border-0">
            <div className="card-body py-4 mb-2">
              <Link to="/home">
                <img src="/assets/images/icon.png" width="70" alt="" />
              </Link>
              <div className="mt-3">
                <h5 className="text-white lh-md">
                  Acharyakulam
                  <br />
                  <span className="fs-5">
                    {user?.currentSession?.replace("-", " - ")}
                  </span>
                </h5>
                <p className="text-white fs-6 m-0 lh-sm text-capitalize">
                  {user?.name}
                </p>
                <p className="text-white fs-6 lh-sm mb-2">
                  Account ID &mdash; {user?.userId}
                </p>
                <p className="text-white fs-6 lh-sm">
                  {new Date().toLocaleDateString("en-GB")}
                </p>
                <span
                  onClick={handleLogout}
                  className="btn btn-white btn-sm mt-1 fw-medium px-4 me-1"
                >
                  Logout
                </span>
                <Link to="/settings" className="btn btn-white btn-sm mt-1 px-3">
                  <i className="bi bi-gear text-dark"></i>
                </Link>
              </div>
            </div>
          </div>
          <ul className="navbar-nav flex-column py-4" id="sideNavbar">
            {hasAccess("Admin Users", user?.roles) && (
              <>
                <li class="nav-item">
                  <div class="navbar-heading">Admin Users</div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navAdministrator"
                    aria-expanded="false"
                    aria-controls="navAdministrator"
                  >
                    <i className="nav-icon bi bi-people me-2" />
                    Manage Administrator
                  </a>
                  <div
                    id="navAdministrator"
                    className="collapse"
                    data-bs-parent="#sideNavbar"
                  >
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <NavLink to="/user-details" className="nav-link">
                          User Details
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="/live-event" className="nav-link">
                          Live Event
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Activity Logs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Chat Messaging Report
                        </a>
                      </li>
                      <li className="nav-item pb-2">
                        <NavLink className="nav-link " to="/complain-box">
                          Complain Box
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <div class="nav-divider"></div>
                </li>
              </>
            )}
            <li class="nav-item">
              <div class="navbar-heading">Modules</div>
            </li>
            {hasAccess("Front Office", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navaccount"
                  aria-expanded="false"
                  aria-controls="navaccount"
                >
                  <i className="nav-icon bi bi-buildings me-2" />
                  Front Office
                </a>
                <div
                  id="navaccount"
                  className="collapse show"
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/gate-pass">
                        Gate Pass
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/medical-alert">
                        Medical Alert
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/admission-enquiry">
                        Admission Enquiry
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink className="nav-link " to="/visitor-book">
                        Visitor Book
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink className="nav-link " to="/view-student-details">
                        Student Details
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Student Information", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navsettings"
                  aria-expanded="false"
                  aria-controls="navsettings"
                >
                  <i className="nav-icon bi bi-person me-2" />
                  Student Information
                </a>
                <div
                  id="navsettings"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/student-details">
                        Student Details
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/scholarship">
                        Scholarship
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/left-students" className="nav-link ">
                        Left Students
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink to="/inactive-students" className="nav-link ">
                        Inactive Students
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Fees Collection", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navroutine"
                  aria-expanded="false"
                  aria-controls="navroutine"
                >
                  <i className="nav-icon bi bi-wallet me-2" />
                  Fees Collection
                </a>
                <div
                  id="navroutine"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink to="/monthly-fees" className="nav-link ">
                        Monthly Fees
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/check-payment-status" className="nav-link ">
                        Check Payment Status
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/miscellaneous-fees" className="nav-link ">
                        Miscellaneous Fees
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/admission-form" className="nav-link ">
                        Admission Form
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/dues-fee">
                        Dues Fee
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/paid-fee">
                        Paid Fee
                      </NavLink>
                    </li>
                    {(userRole?.includes("Master Admin") ||
                      userRole?.includes("Admin")) && (
                      <li className="nav-item">
                        <NavLink
                          className="nav-link "
                          to="/collectedby-summary"
                        >
                          CollectedBy Summary
                        </NavLink>
                      </li>
                    )}
                    <li className="nav-item pb-2">
                      <NavLink className="nav-link " to="/fees-master">
                        Fees Master
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Behaviour Records", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navCourses"
                  aria-expanded="false"
                  aria-controls="navCourses"
                >
                  <i className="nav-icon bi bi-people me-2" />
                  Behaviour Records
                </a>
                <div
                  id="navCourses"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/incidents">
                        Incidents
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink
                        to="/assign-view-incidents"
                        className="nav-link "
                      >
                        Assign / View Incidents
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Expenses", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navProfile"
                  aria-expanded="false"
                  aria-controls="navProfile"
                >
                  <i className="nav-icon bi bi-currency-rupee me-2" />
                  Expenses
                </a>
                <div
                  id="navProfile"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/expense-details">
                        Expense Details
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <a className="nav-link " href="#">
                        Search Expense
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Examinations", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navCMS"
                  aria-expanded="false"
                  aria-controls="navCMS"
                >
                  <i className="nav-icon bi bi-book me-2" />
                  Examinations
                </a>
                <div
                  id="navCMS"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink to="/syllabus" className="nav-link">
                        Syllabus
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/sample-paper" className="nav-link">
                        Sample Paper
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/admit-card" className="nav-link">
                        Admit Card
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/examination-marks" className="nav-link">
                        Examination Marks
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/result" className="nav-link">
                        Result
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink to="/toppers" className="nav-link">
                        Toppers
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Attendance", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navProject"
                  aria-expanded="false"
                  aria-controls="navProject"
                >
                  <i className="nav-icon bi bi-graph-up me-2" />
                  Attendance
                </a>
                <div
                  id="navProject"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink to="/school-attendance" className="nav-link ">
                        School Attendance
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/applied-leave" className="nav-link ">
                        Applied Leave
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to="/class-section-attendance"
                        className="nav-link "
                      >
                        Class / Section Attendance
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink
                        to="/school-attendance-statistics"
                        className="nav-link "
                      >
                        School Attendance Statistics
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Human Resource", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navecommerce"
                  aria-expanded="false"
                  aria-controls="navecommerce"
                >
                  <i className="nav-icon bi bi-person-standing me-2" />
                  Human Resource
                </a>
                <div
                  id="navecommerce"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink to="/staff-directory" className="nav-link ">
                        Staff Directory
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/staff-attendance" className="nav-link">
                        Staff Attendance
                      </NavLink>
                    </li>
                    {/* <li className="nav-item">
                      <a className="nav-link " href="#">
                        Payroll
                      </a>
                    </li>*/}
                    <li className="nav-item ">
                      <NavLink to="/staff-applied-leave" className="nav-link">
                        Leave Request
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink to="/left-staff" className="nav-link ">
                        Left Staffs
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Communicate", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navlayouts"
                  aria-expanded="false"
                  aria-controls="navlayouts"
                >
                  <i className="nav-icon bi bi-chat me-2" />
                  Communicate
                </a>
                <div
                  id="navlayouts"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/holidays">
                        Holidays
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link " to="/notice-board">
                        Notice Board
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink
                        className="nav-link "
                        to="/send-push-notification"
                      >
                        Send Push Notification
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink className="nav-link " to="/send-dfs-message">
                        Send DFS Message
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink className="nav-link " to="/send-sms">
                        Send SMS
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink className="nav-link " to="/send-email">
                        Send Email
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink className="nav-link " to="/sms-template">
                        SMS Template
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Homework", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navreports"
                  aria-expanded="false"
                  aria-controls="navreports"
                >
                  <i className="nav-icon bi bi-ui-radios me-2" />
                  Homework
                </a>
                <div
                  id="navreports"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink to="/homework" className="nav-link ">
                        Today's Homework
                      </NavLink>
                    </li>
                    <li className="nav-item pb-2">
                      <NavLink to="/homework-statistics" className="nav-link">
                        Statistics
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Library", user?.roles) && (
              <>
                <li className="nav-item">
                  <a
                    className="nav-link  collapsed "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navcertificate"
                    aria-expanded="false"
                    aria-controls="navcertificate"
                  >
                    <i className="nav-icon bi bi-stickies me-2" />
                    Library
                  </a>
                  <div
                    id="navcertificate"
                    className="collapse "
                    data-bs-parent="#sideNavbar"
                  >
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <NavLink to="/book-list" className="nav-link ">
                          Book List
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to="/book-issue-return-student"
                          className="nav-link "
                        >
                          Book Issue / Return (S)
                        </NavLink>
                      </li>
                      {/* <li className="nav-item">
                        <a className="nav-link " href="#">
                          Book Issue / Return (T)
                        </a>
                      </li> */}
                      <li className="nav-item pb-2">
                        <NavLink to="/e-book-list" className="nav-link ">
                          E-Book List
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )}
            {/* {hasAccess("Inventory", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbulk"
                  aria-expanded="false"
                  aria-controls="navbulk"
                >
                  <i className="nav-icon bi bi-rocket-takeoff me-2" />
                  Inventory
                </a>
                <div
                  id="navbulk"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Issue Item
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Add Item Stock
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Add Item
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Item Category
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Item Store
                      </a>
                    </li>
                    <li className="nav-item pb-2">
                      <a className="nav-link " href="#">
                        Item Supplier
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            )} */}
            {hasAccess("Transport Management", user?.roles) && (
              <>
                <li class="nav-item">
                  <a
                    class="nav-link  collapsed "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navMenuLevel"
                    aria-expanded="false"
                    aria-controls="navMenuLevel"
                  >
                    <i className="nav-icon bi bi-bus-front-fill me-2" />
                    Transport Management
                  </a>
                  <div
                    id="navMenuLevel"
                    class="collapse "
                    data-bs-parent="#sideNavbar"
                  >
                    <ul class="nav flex-column">
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/bus-stoppage">
                          Bus Stoppage
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/bus-route">
                          Bus Route
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/bus-timing">
                          Bus Timing
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/bus-details">
                          Bus Details
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/left-buses">
                          Left Buses
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/track-bus">
                          Track Bus
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          className="nav-link"
                          to="/student-transport-details"
                        >
                          Student Details
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/staff-directory">
                          Staff Details
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/driver-details">
                          Driver Details
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/left-drivers">
                          Left Drivers
                        </NavLink>
                      </li>
                      <li class="nav-item pb-2">
                        <a
                          class="nav-link "
                          href="#"
                          data-bs-toggle="collapse"
                          data-bs-target="#navMenuLevelSecond"
                          aria-expanded="false"
                          aria-controls="navMenuLevelSecond"
                        >
                          Manage Attendance
                        </a>
                        <div
                          id="navMenuLevelSecond"
                          class="collapse"
                          data-bs-parent="#navMenuLevel"
                        >
                          <ul class="nav flex-column">
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                to="/bus-attendance"
                              >
                                Bus Attendance
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                to="/bus-wise-attendance"
                              >
                                Bus Wise Attendance
                              </NavLink>
                            </li>
                            <li className="nav-item pb-2">
                              <NavLink
                                className="nav-link"
                                to="/bus-attendance-statistics"
                              >
                                Bus Attendance Statistics
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )}
            {/* {hasAccess("Certificate", user?.roles) && (
              <li className="nav-item">
                <a
                  className="nav-link  collapsed "
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#navsalary"
                  aria-expanded="false"
                  aria-controls="navsalary"
                >
                  <i className="nav-icon bi bi-files me-2" />
                  Certificate
                </a>
                <div
                  id="navsalary"
                  className="collapse "
                  data-bs-parent="#sideNavbar"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Transfer Certificate
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Cancel TC
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Bonafide
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link " href="#">
                        Tution Fee
                      </a>
                    </li>
                    <li className="nav-item pb-2">
                      <a className="nav-link" href="#">
                        Fee Paid (All Receipts)
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasAccess("Timetable", user?.roles) && (
              <>
                <li class="nav-item">
                  <a
                    class="nav-link  collapsed "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#TimetableLevel"
                    aria-expanded="false"
                    aria-controls="TimetableLevel"
                  >
                    <i className="nav-icon bi bi-clock me-2" />
                    Timetable Scheduling
                  </a>
                  <div
                    id="TimetableLevel"
                    class="collapse "
                    data-bs-parent="#sideNavbar"
                  >
                    <ul class="nav flex-column">
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/">
                          Class Teacher Allocation
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/">
                          Automated Timetable
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/">
                          Teacher Substitution
                        </NavLink>
                      </li>
                      <li className="nav-item pb-2">
                        <NavLink className="nav-link" to="/">
                          Custom Scheduling Rules
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )} */}
            {hasAccess("Vendor", user?.roles) && (
              <>
                <li class="nav-item">
                  <a
                    class="nav-link  collapsed "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#VendorLevel"
                    aria-expanded="false"
                    aria-controls="VendorLevel"
                  >
                    <i className="nav-icon bi bi-people me-2" />
                    Vendors
                  </a>
                  <div
                    id="VendorLevel"
                    class="collapse "
                    data-bs-parent="#sideNavbar"
                  >
                    <ul class="nav flex-column">
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/vendors">
                          Manage Vendors
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/contracts-renewals">
                          Contracts & Renewals
                        </NavLink>
                      </li>
                      <li className="nav-item pb-2">
                        <NavLink className="nav-link" to="/payment-tracking">
                          Payment Tracking
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )}
            {hasAccess("Reports", user?.roles) && (
              <>
                <li class="nav-item">
                  <a
                    class="nav-link  collapsed "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#ReportsLevel"
                    aria-expanded="false"
                    aria-controls="ReportsLevel"
                  >
                    <i className="nav-icon bi bi-download me-2" />
                    Reports & Analytics
                  </a>
                  <div
                    id="ReportsLevel"
                    class="collapse "
                    data-bs-parent="#sideNavbar"
                  >
                    <ul class="nav flex-column">
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/students">
                          Students
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/finance">
                          Finance
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/attendance">
                          Attendance
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/examination">
                          Examination
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/homework">
                          Homework
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/staffs">
                          HR Management
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/front-office">
                          Front Office
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="nav-link" to="/reports/library">
                          Library
                        </NavLink>
                      </li>
                      <li className="nav-item pb-2">
                        <NavLink className="nav-link" to="/reports/transport">
                          Transport
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              </>
            )}

            {hasAccess("Website", user?.roles) && (
              <>
                <li class="nav-item">
                  <div class="nav-divider"></div>
                </li>
                <li class="nav-item">
                  <div class="navbar-heading">Website</div>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navDashboard"
                    aria-expanded="false"
                    aria-controls="navDashboard"
                  >
                    <i className="nav-icon bi bi-images me-2" />
                    Gallery & Achivement
                  </a>
                  <div
                    id="navDashboard"
                    className="collapse"
                    data-bs-parent="#sideNavbar"
                  >
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Photos
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link " href="#">
                          Vidoes
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link " href="#">
                          Media Print
                        </a>
                      </li>
                      <li className="nav-item pb-2">
                        <a className="nav-link " href="#">
                          Blogs and Articles
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item">
                  <a class="nav-link " href="#">
                    <i class="nav-icon bi bi-wallet me-2"></i>
                    Fee Structure
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link " href="#">
                    <i class="nav-icon bi bi-files me-2"></i>
                    Admission Syllabus
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link " href="#">
                    <i class="nav-icon bi bi-files me-2"></i>
                    Calendar
                  </a>
                </li>
              </>
            )}
          </ul>

          <div className="card bg-primary shadow-none rounded-bottom-0 text-center mx-3 border-0 mt-2">
            <div className="card-body py-2"></div>
          </div>
        </div>
      </nav>

      <nav className="navbar-default navbar py-2 navbar-expand-lg sticky-top z-2 d-flex justify-content-center frosted">
        <div className="header-navbar-w"></div>
        <div className="row w-100">
          <div className="col-lg-2 d-flex justify-content-center">
            <div className="bg-light rounded-end-pill w-100"></div>
            <ul className="navbar-nav navbar-right-wrap ms-2 d-flex nav-top-wrap align-items-center">
              <li className="me-2">
                <Link
                  to="/home"
                  class="btn btn-light btn-icon rounded-circle d-flex align-items-center"
                >
                  <i class="bi bi-house"></i>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 d-flex justify-content-center">
            <ul className="navbar-nav navbar-right-wrap ms-2 d-flex nav-top-wrap align-items-center">
              <li className="me-2">
                <ThemeSwitcher />
              </li>
              <li className="me-2">
                <button
                  class="btn btn-light btn-icon rounded-circle d-flex align-items-center"
                  onClick={toggleFullScreen}
                >
                  <i class="bi bi-arrows-fullscreen"></i>
                </button>
              </li>
              <li className="me-2">
                <a
                  className="dropdown-item rounded-pill bg-light fs-5"
                  href="#"
                >
                  <i className="bi bi-megaphone me-2" />
                  Notice
                </a>
              </li>
              <li className="me-2">
                <Link
                  to="/settings"
                  className="dropdown-item rounded-pill bg-light fs-5"
                >
                  <i className="bi bi-gear me-2" />
                  A/C Settings
                </Link>
              </li>
              <li className="me-2">
                <a
                  className="btn btn-light btn-icon rounded-circle indicator indicator-primary"
                  href="#"
                >
                  <i className="bi bi-bell" />
                </a>
              </li>
              <li className="me-2">
                <div
                  className="btn btn-danger btn-icon rounded-circle"
                  onClick={handleLogout}
                >
                  <i className="bi bi-power" />
                </div>
              </li>
              <li className="me-2">
                <VoiceNavigator />
              </li>
            </ul>
          </div>
          <div className="col-lg-4 d-flex justify-content-end">
            <ul className="navbar-nav navbar-right-wrap ms-2 d-flex nav-top-wrap align-items-center w-100">
              <li className="me-4 w-100">
                <form className="d-flex justify-content-end align-items-center">
                  <div className="position-relative w-100">
                    {/* 👻 Ghost Suggestion */}
                    <input
                      type="text"
                      className="form-control ps-5 rounded-3 border-0 header-search-bg text-muted position-absolute top-0 start-0 w-100 z-1"
                      value={suggestion ? search + getRemainingText() : ""}
                      readOnly
                      style={{
                        opacity: 0.4,
                        pointerEvents: "none",
                      }}
                    />

                    {/* ✍️ Actual Input */}
                    <input
                      type="text"
                      className="form-control ps-5 rounded-3 border-0 header-search-bg position-relative bg-transparent"
                      placeholder="Looking For ?"
                      value={search}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      autoComplete="off"
                    />

                    {/* 🔍 Icon */}
                    <span
                      className="position-absolute pe-4"
                      style={{
                        right: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <i className="bi bi-search text-dark" />
                    </span>
                  </div>
                </form>
              </li>
              <li>
                <Link to="/settings">
                  <div class="position-relative d-flex align-items-end">
                    <img
                      src={`/assets/images/users/${user?.name}.jpg`}
                      className="btn-icon rounded-circle object-fit-cover"
                    />
                    <div class="position-absolute ms-n2">
                      <img
                        src="/assets/images/checked-mark.svg"
                        alt=""
                        height="22"
                        width="22"
                      />
                    </div>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
